// 桔子权益场景，中转页，获取权益购买结果后跳转臻有钱首页
import { RouteConfig } from 'vue-router';
import { RouterV2Enum } from '../router-names';

export default (): RouteConfig[] => ([
  {
    path: RouterV2Enum.transfer,
    name: 'transfer',
    component: () => import(/* webpackChunkName: "transfer" */ '@/views_v2/transfer'),
    props: (route) => ({
      supplierCode: String(route.query.supplierCode || ''),
    }),
    meta: {
      pageId: 'finance_memberShipCenter_loading',
      title: '臻有钱',
      isShowH5Nav: true,
    },
  },
]);
